/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDatabricks = (props: Props) => (
  <Icon viewBox="0 0 25 24" {...props}>
    <g fill="none">
      <path
        d="m2.5 13.911 10 5.442 8.976-4.857v1.934l-8.976 4.9-9.488-5.216-.511.27v.673L12.5 22.5l10-5.44v-3.778l-.466-.27-9.534 5.216-8.93-4.946v-1.934l8.93 4.856 10-5.44V7.03l-.466-.27-9.534 5.217-8.464-4.631L12.5 2.714l7.023 3.822.604-.36v-.494L12.5 1.5l-10 5.486v.63l10 5.44L21.477 8.2v1.977L12.5 15.08 3.012 9.865l-.511.27z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDatabricks as Databricks };
